import React from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#084A70] text-white/80 py-12 border-t border-white/10" data-id="element-247" data-mp="3gfsoch60l2p3">
      <div className="container mx-auto px-4" data-id="element-248" data-mp="32nuhkczrziw3">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-249" data-mp="32p5qssbzpiul">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-250" data-mp="36q953aee36tp">
            <a href="#" className="inline-block mb-6" data-id="element-251" data-mp="3ufa4671c15mb">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m3nP7fc9XV1ZSHtYcih2QJ/Beach_Club_Logo.png" alt="Beach Club Logo" className="h-20 w-20 object-cover rounded-full border-2 border-white/20" data-id="element-252" data-mp="3ufjvbxy45itl" />
            </a>
            <p className="text-sm leading-relaxed mb-6" data-id="element-253" data-mp="3lgon6gbidynn">
              מועדון הגלישה והחתירה המוביל בכנרת. מקצועיות, בטיחות ואהבה לים הם
              הערכים שמובילים אותנו.
            </p>
            <div className="flex gap-4" data-id="element-254" data-mp="2a19uvpu8vuyv">
              <a href="#" className="hover:text-white transition-colors bg-white/5 p-2 rounded-full hover:bg-white/20" data-id="element-255" data-mp="2eyjrpqjyr8wq">
                <Facebook className="w-5 h-5" data-id="element-256" data-mp="3labovo69tsmo" />
              </a>
              <a href="#" className="hover:text-white transition-colors bg-white/5 p-2 rounded-full hover:bg-white/20" data-id="element-257" data-mp="3gapfjptkcwj5">
                <Instagram className="w-5 h-5" data-id="element-258" data-mp="3v8rhxwouzbyt" />
              </a>
              <a href="#" className="hover:text-white transition-colors bg-white/5 p-2 rounded-full hover:bg-white/20" data-id="element-259" data-mp="3q8n0o4g4md7j">
                <Youtube className="w-5 h-5" data-id="element-260" data-mp="82ihe6dukyl6" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-261" data-mp="335slg3f1hfy">
            <h4 className="text-white font-bold mb-6" data-id="element-262" data-mp="33e3x3jw4ep1">ניווט מהיר</h4>
            <ul className="space-y-3 text-sm" data-id="element-263" data-mp="ht3dnn61tr0x">
              <li data-id="element-264" data-mp="huwlv6wb8jb1">
                <a href="/" className="hover:text-white transition-colors" data-id="element-265" data-mp="ctqrz5qwypzx">
                  דף הבית
                </a>
              </li>
              <li data-id="element-266" data-mp="qub81u5g27pq">
                <a href="/sup" className="hover:text-white transition-colors" data-id="element-267" data-mp="qtrpcb7yzfan">
                  SUP
                </a>
              </li>
              <li data-id="element-268" data-mp="tvcz5qtmo3em">
                <a href="/sup-race" className="hover:text-white transition-colors" data-id="element-269" data-mp="tvw6yepkdbex">
                  SUP Race
                </a>
              </li>
              <li data-id="element-270" data-mp="ys3f8e5fmz01">
                <a href="/sup-tours" className="hover:text-white transition-colors" data-id="element-271" data-mp="13tam8azr3u5n">
                  טיולי סאפ
                </a>
              </li>
              <li data-id="element-272" data-mp="18ksmsxxv3sq3">
                <a href="/surfski" className="hover:text-white transition-colors" data-id="element-273" data-mp="18lbvdo1mh4rg">
                  קיאק Surfski
                </a>
              </li>
              <li data-id="element-274" data-mp="1hk5vvpi2qfaa">
                <a href="/wingfoil" className="hover:text-white transition-colors" data-id="element-275" data-mp="1hje2mlby8tn6">
                  Wing Foil
                </a>
              </li>
              <li data-id="element-276" data-mp="1riv6cx7n4xgi">
                <a href="/events" className="hover:text-white transition-colors" data-id="element-277" data-mp="1rjeqmkkrjxxp">
                  אירועים וסדנאות
                </a>
              </li>
              <li data-id="element-278" data-mp="3oczot9hfgf5i">
                <a href="/#contact" className="hover:text-white transition-colors" data-id="element-279" data-mp="3odhs2q2ibtmx">
                  צור קשר
                </a>
              </li>
            </ul>
          </div>

          {/* Activities */}
          <div data-id="element-280" data-mp="25oexs0w4xofq">
            <h4 className="text-white font-bold mb-6" data-id="element-281" data-mp="25nvh0ni8163a">פעילויות</h4>
            <ul className="space-y-3 text-sm" data-id="element-282" data-mp="25mkcumkv5wbn">
              <li data-id="element-283" data-mp="21nv4x9ilh6ze">
                <a href="#" className="hover:text-white transition-colors" data-id="element-284" data-mp="21nbjvjxne2h5">
                  שיעורי גלישה
                </a>
              </li>
              <li data-id="element-285" data-mp="2tdpth3ymosn0">
                <a href="#" className="hover:text-white transition-colors" data-id="element-286" data-mp="2te9cyp3xfp35">
                  השכרת ציוד
                </a>
              </li>
              <li data-id="element-287" data-mp="2pd5v5x2bjiza">
                <a href="#" className="hover:text-white transition-colors" data-id="element-288" data-mp="2pajsobuabtnx">
                  קבוצות חתירה
                </a>
              </li>
              <li data-id="element-289" data-mp="2fd5ao7spqwti">
                <a href="#" className="hover:text-white transition-colors" data-id="element-290" data-mp="2fdosloid5l7j">
                  אירועים פרטיים
                </a>
              </li>
              <li data-id="element-291" data-mp="13zb8muqqdpws">
                <a href="#" className="hover:text-white transition-colors" data-id="element-292" data-mp="13ys1m92mclxj">
                  ימי גיבוש
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-293" data-mp="2wmpo2fo6voj4">
            <h4 className="text-white font-bold mb-6" data-id="element-294" data-mp="2wn97y1xegmzs">הישארו מעודכנים</h4>
            <p className="text-sm mb-4" data-id="element-295" data-mp="2ivkvtyn5hyit">
              הירשמו לניוזלטר שלנו לקבלת עדכונים על אירועים ומבצעים
            </p>
            <form className="flex gap-2" data-id="element-296" data-mp="2nuxm6td8dnq5">
              <input type="email" placeholder="האימייל שלך" className="bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-sm text-white placeholder-white/50 focus:outline-none focus:border-white w-full" data-id="element-297" data-mp="2nrrxvgcfepvh" />
              <button className="bg-white text-[#084A70] px-4 py-2 rounded-lg text-sm font-bold hover:bg-blue-50 transition-colors" data-id="element-298" data-mp="31lsv25nqc4tq">
                שלח
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8" data-id="element-299" data-mp="1q64658qx0vqa">
          <div className="text-center text-xs" data-id="element-300" data-mp="1q8qf9ctgfjam">
            <p data-id="element-301" data-mp="1v6i4fz2psrb4">
              &copy; {new Date().getFullYear()} Beach Club Maagan Eden. כל
              הזכויות שמורות.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}